/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PublicTherapistSettings } from './PublicTherapistSettings';
export type MinimalWhoAmITherapist = {
    id: number;
    name: string;
    slug: string;
    type: MinimalWhoAmITherapist.type;
    image: string | null;
    isActive: boolean;
    plan: MinimalWhoAmITherapist.plan;
    settings: PublicTherapistSettings;
};
export namespace MinimalWhoAmITherapist {
    export enum type {
        THERAPIST = 'therapist',
        CONSULTANT = 'consultant',
        COACH = 'coach',
        OTHER = 'other',
    }
    export enum plan {
        FREE = 'free',
        PAID = 'paid',
        MULTI_USER = 'multiUser',
    }
}

